module.exports = __webpack_public_path__ + "img/current.b8195565.svg";